import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import 'root-consent'
import 'root-consent/dist/js/plugins/google-analytics';
import objectFitImages from 'object-fit-images';
import 'core-js/actual/object/group-by';

import { AnimateObserver } from './lib/animate-observer';
import { Sticky } from './lib/sticky';
import { Trigger } from './lib/trigger';
import { LazyLoad } from './lib/lazy-load';

objectFitImages();

const animate = new AnimateObserver();
animate.init();

const sticky = new Sticky();
sticky.init();

const trigger = new Trigger();
trigger.init();

const lazy = new LazyLoad();
lazy.init();

const isUs = window.location.pathname.startsWith('/us/');
const ukText = 'This website uses cookies to ensure you get the best experience on our website. Visit our <a href="https://shdcomposites.com/cookie-policy">cookie policy</a> and our <a href="https://shdcomposites.com/privacy-policy">privacy policy</a> for more info.';
const usText = 'This website uses cookies to ensure you get the best experience on our website. Visit our <a href="https://shdcomposites.com/us/cookie-policy">cookie policy</a> and our <a href="https://shdcomposites.com/us/privacy-policy">privacy policy</a> for more info.';

const consent = new rootConsent( 'body', {
    messageText: isUs ? usText : ukText,
    approveLabel: 'Confirm',
    delay: 500,
    alwaysApproved: false
} );

console.log(consent);

consent.registerPlugin( 'google-analytics',{
    trackingID: 'UA-74767952-1'
} );

if ( document.querySelector( '.js-carousel' ) ) {

    import('./lib/carousel').then( module1 => {
        const carousel = new module1.Carousel();
        carousel.init();
        if ( document.querySelector( '.js-filter' ) ) {
            import('./lib/converter').then( module2 => {
                const converter = new module2.Converter();
                converter.init();
                import('./lib/filter').then( module3 => {
                    const filter = new module3.Filter( carousel, converter );
                    filter.init();
                } );
            } );
        }
    } );
}

if ( document.querySelector( '.js-file' ) ) {
    import('./lib/file').then( module => {
        const files = new module.FileUploadInput();
        files.init();
    } );
}

if ( document.querySelector( '.js-market-finder' ) ) {
    import('./lib/market-finder').then( module => {
        const marketFinder = new module.MarketFinder();
        marketFinder.init();
    } );
}

if ( document.querySelector( '.js-map' ) ) {
    // import module for side effects
    import('@googlemaps/js-api-loader').then( module => {
        const loader = new module.Loader( {
            apiKey: process.env.GMAPS_API_KEY, // Change
            version: 'weekly',
            libraries: []
        } );

        loader.load().then( ( google ) => {

            import('./lib/map').then( module => {
                const maps = new module.Maps( google );
                maps.init();
            } );
        } )
    } );
}

import('./lib/turnstile').then( module => {
    const turnstile = new module.Turnstile();
    if(turnstile) {
        turnstile.init()
    }
    window.onloadTurnstileCallback = function() {
        turnstile.init()
    }
} );
